<script setup lang="ts">
import { TITLE_PAGE } from '#shared/constant/constant'
import { postWindowBridge } from '@/utils/windowBridge'

const isLoading = ref(true)

onMounted(() => {
  const data = { Screen: 'CatalogTop', ContentGroup: 'カタログ' }
  postWindowBridge('gtagApp', JSON.stringify(data))
  postWindowBridge('toggleCloseButton', false)
  postWindowBridge('toggleTopButton', false)
  postWindowBridge('toggleShareButton', false)
  postWindowBridge('toggleBottomBar', true)
  postWindowBridge('setAppBarTitle', TITLE_PAGE.catalog_top)
  postWindowBridge('toggleFavoriteButton', false)
  isLoading.value = false
})

useHead({
  title: TITLE_PAGE.catalog_top,
})
</script>
<template>
  <SpinnerCircleSpinner :is-loading="isLoading" />
  <div v-show="!isLoading">
    <div class="container">
      <DatadisplayCatalogTopPickupSlide />
    </div>
    <DatadisplayCatalogTopCatalogSearch />
    <div class="container">
      <DatadisplayCatalogTopLatestCatalog />
    </div>
    <DatadisplayCatalogTopConditionFinds />
  </div>
  <ModalCarSizeModal />
</template>
<style scoped>
.title {
  margin-top: 40px;
  font-size: 20px;
  font-weight: bold;
}
</style>
